<template>
  <section class="user-info">
    <header
      v-if="title"
      class="user-info__header"
    >
      <h2>{{ title }}</h2>

      <VBtn
        v-if="!readonly"
        :to="{name: 'user-edit', query: { settings: anchor }}"
        class="ml-2"
        x-small
        text
        color="primary"
      >
        {{ $t('edit.one') }}
      </VBtn>
    </header>

    <div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'UserInfo',
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: ''
    },

    readonly: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
  .user-info {
    margin-top: 1.5rem;
  }

  .user-info__header {
    font-size: map-deep-get($headings, 'h3', 'font-size');
    display: flex;
    margin-bottom: 2rem;
  }
</style>
